import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const UploadIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Frame">
        <path
          id="Vector"
          d="M12.5 1.6665H4.99998C4.55795 1.6665 4.13403 1.8421 3.82147 2.15466C3.50891 2.46722 3.33331 2.89114 3.33331 3.33317V16.6665C3.33331 17.1085 3.50891 17.5325 3.82147 17.845C4.13403 18.1576 4.55795 18.3332 4.99998 18.3332H15C15.442 18.3332 15.8659 18.1576 16.1785 17.845C16.4911 17.5325 16.6666 17.1085 16.6666 16.6665V5.83317L12.5 1.6665Z"
          stroke={fillColor || '#9D9DA6'}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M11.6667 1.6665V4.99984C11.6667 5.44186 11.8423 5.86579 12.1548 6.17835C12.4674 6.49091 12.8913 6.6665 13.3334 6.6665H16.6667"
          stroke={fillColor || '#9D9DA6'}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path id="Vector_3" d="M10 10V15" stroke={fillColor || '#9D9DA6'} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
        <path
          id="Vector_4"
          d="M12.5 12.5L10 10L7.5 12.5"
          stroke={fillColor || '#9D9DA6'}
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export { UploadIcon };
